import { firebase } from "../firebase";

export const isCurrentUser = user => {
  const currentUser = firebase.auth().currentUser;
  if (!user || !currentUser) return false;
  return user.userId === currentUser.uid;
};
